var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._g({style:([_vm.taskLength, _vm.squareCorners])},_vm.$listeners),[_vm._v("\n    "+_vm._s(_vm.name)+" "),(_vm.whenItsDone)?_c('span',[_vm._v("🚀")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }